export default class SavedGraph {
  constructor() {
    this.Entities = [];
    this.Relations = [];
    this.connections = [];
  }
}
